import { render, staticRenderFns } from "./FeedbackDetail.vue?vue&type=template&id=de17aa82&scoped=true&"
import script from "./FeedbackDetail.vue?vue&type=script&lang=js&"
export * from "./FeedbackDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackDetail.vue?vue&type=style&index=0&id=de17aa82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de17aa82",
  null
  
)

export default component.exports